import { Controller } from "@hotwired/stimulus"

// Autocomplete doctor: fetch /admin/doctors?q=, pick → fills name/address/phone/id.
export default class extends Controller {
  static targets = ["idField", "nameInput", "addressInput", "phoneInput", "results"]

  connect() {
    this.timeout = null
    this.lastQuery = ""
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  search() {
    if (this.timeout) clearTimeout(this.timeout)
    const q = this.nameInputTarget.value.trim()

    // Clear hidden id when user retypes — otherwise we'd send stale id.
    if (q !== this.lastQuery) {
      this.idFieldTarget.value = ""
    }

    if (q.length < 2) {
      this.hide()
      return
    }

    this.timeout = setTimeout(() => this.fetch(q), 180)
  }

  async fetch(q) {
    this.lastQuery = q
    try {
      const res = await fetch(`/admin/doctors?q=${encodeURIComponent(q)}`, {
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      })
      if (!res.ok) return this.hide()
      const data = await res.json()
      this.render(data)
    } catch (e) {
      this.hide()
    }
  }

  render(items) {
    if (!items.length) return this.hide()
    this.resultsTarget.innerHTML = items.map(d => `
      <li>
        <button type="button"
                data-action="mousedown->doctor-autocomplete#pick"
                data-doctor-id="${d.id}"
                data-doctor-name="${this.escape(d.name)}"
                data-doctor-address="${this.escape(d.address || "")}"
                data-doctor-phone="${this.escape(d.phone || "")}"
                class="w-full text-left px-3 py-2 hover:bg-slate-100">
          <div class="font-medium">${this.escape(d.name)}</div>
          <div class="text-sm text-slate-500">${this.escape(d.address || "")}</div>
        </button>
      </li>
    `).join("")
    this.resultsTarget.classList.remove("hidden")
  }

  pick(event) {
    event.preventDefault()
    this.applyDataset(event.currentTarget.dataset)
    this.hide()
  }

  pickChip(event) {
    this.applyDataset(event.currentTarget.dataset)
    this.hide()
  }

  applyDataset(ds) {
    this.idFieldTarget.value = ds.doctorId || ""
    this.nameInputTarget.value = ds.doctorName || ""
    if (this.hasAddressInputTarget) this.addressInputTarget.value = ds.doctorAddress || ""
    if (this.hasPhoneInputTarget) this.phoneInputTarget.value = ds.doctorPhone || ""
    this.lastQuery = this.nameInputTarget.value.trim()
  }

  hide() {
    this.resultsTarget.classList.add("hidden")
    this.resultsTarget.innerHTML = ""
  }

  hideSoon() {
    // Delay so a click on a result still registers (mousedown handler).
    setTimeout(() => this.hide(), 150)
  }

  escape(str) {
    return String(str).replace(/[&<>"']/g, c => ({
      "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
    })[c])
  }
}
